import { useEffect, useState } from "react";
import { X, Download, Share } from "lucide-react";

const DISMISS_KEY = "hm_install_dismissed";

export const InstallPrompt = () => {
  const [deferred, setDeferred] = useState(null);
  const [showIosTip, setShowIosTip] = useState(false);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (localStorage.getItem(DISMISS_KEY)) return;
    const standalone = window.matchMedia("(display-mode: standalone)").matches || window.navigator.standalone;
    if (standalone) return;

    const onPrompt = (e) => {
      e.preventDefault();
      setDeferred(e);
      setVisible(true);
    };
    window.addEventListener("beforeinstallprompt", onPrompt);

    const isIos = /iphone|ipad|ipod/i.test(window.navigator.userAgent);
    if (isIos) {
      setShowIosTip(true);
      setVisible(true);
    }
    return () => window.removeEventListener("beforeinstallprompt", onPrompt);
  }, []);

  const dismiss = () => {
    localStorage.setItem(DISMISS_KEY, "1");
    setVisible(false);
  };

  const install = async () => {
    if (!deferred) return;
    deferred.prompt();
    await deferred.userChoice;
    dismiss();
  };

  if (!visible) return null;

  return (
    <div data-testid="install-banner" className="fixed inset-x-3 bottom-3 z-[60] mx-auto max-w-md rounded-2xl border border-sand-200 bg-white p-4 shadow-xl sm:inset-x-auto sm:right-5 sm:bottom-5">
      <div className="flex items-start gap-3">
        <img src="/icons/icon-192.png" alt="" className="h-10 w-10 rounded-xl border border-sand-200" />
        <div className="min-w-0 flex-1">
          <p className="text-sm font-medium text-charcoal-800">Install Hola Movers</p>
          {showIosTip && !deferred ? (
            <p className="mt-0.5 text-xs text-charcoal-500">
              Tap <Share size={12} className="inline -mt-0.5" /> Share, then "Add to Home Screen" to install this app.
            </p>
          ) : (
            <p className="mt-0.5 text-xs text-charcoal-500">Add the app to your home screen for one-tap access.</p>
          )}
        </div>
        <button data-testid="install-dismiss" onClick={dismiss} aria-label="Dismiss" className="text-charcoal-400 hover:text-charcoal-700"><X size={16} /></button>
      </div>
      {deferred && (
        <button data-testid="install-confirm" onClick={install}
          className="mt-3 inline-flex w-full items-center justify-center gap-2 rounded-full bg-terracotta px-4 py-2 text-sm font-medium text-white hover:bg-terracotta-hover">
          <Download size={15} /> Install app
        </button>
      )}
    </div>
  );
};
